import React from 'react';
import { ReviewStars } from '../../../../../components/Review';
import './styles.css';

const Reviews = ({ averageRating, count }) => {
  return (
    !!count && (
      <ReviewStars
        className="Listview__Card__reviews"
        countText={`(${count})`}
        rating={averageRating}
        average={averageRating}
        width={15}
      />
    )
  );
};
export default Reviews;
